import { app } from '../../../../../../app';
import { Controller } from './download-agent.controller';

app.component('companyDirectoryIntegrationManageConnectionDownloadAgent', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./download-agent.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/download-agent/download-agent.component.js